import React from 'react'
import PropTypes from 'prop-types';

import { Row, Col, FormGroup, Label, Switch } from 'twyne-new.ui';
import { PureSwitch } from 'components/form/Switch';
import CodeEditor from '@Components/form/CodeEditor';


class TcpaFormForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tcpaform: {},
      customFields: null,
      customFieldSelected: null
    }
  }

  componentWillMount() {
    this.updateCustomFields(this.props);
    this.handleEnableManualSubmit({ target: { checked: true } })
  }

  componentWillReceiveProps(props) {
    this.updateCustomFields(props);
  }

  updateCustomFields = ({ integrationData: { extraFields, tcpaform } }) => {

    const customFields = (extraFields || []).map(({
      id, group, type, options, key: value, name: label
    }) => ({
      id, group, type, options, value, label: `${label} (${type})`
    }));
    const customFieldSelected = customFields.find(field => tcpaform.cfid === field.value) || {};
    tcpaform.cfid_number = tcpaform.cfid_number || customFieldSelected.id;

    this.state = {
      tcpaform,
      customFields,
      customFieldSelected
    };

  }

  handleEnable = field => ({ target: { checked } }) => {
    this.props.onChange(field, checked)
  }

  handleEnableManualSubmit = evt => {
    this.handleEnable('manualSubmit').call(this, evt)
    evt.target.checked && this.props.onCustomFieldClick({ hideHostedSubmit: false })
  }

  handleEnableLeadId = (e) => {
    let checked = e.target.checked

    if (checked) {
      if (this.state.tcpaform.cfid === null || this.state.tcpaform.cfid === undefined) return
      this.props.onChange('leadid', checked)
      this.props.onChange('leadid_cfid', `${this.state.tcpaform.cfid}_leadid`)
    } else {
      this.props.onChange('leadid', false)
      this.props.onChange('leadid_cfid', '')
    }

  }

  handleEnableTrustedForm = (e) => {
    let checked = e.target.checked

    if (checked) {
      if (this.state.tcpaform.cfid === null || this.state.tcpaform.cfid === undefined) return
      this.props.onChange('trustedform', checked)
      this.props.onChange('trustedform_cfid', `${this.state.tcpaform.cfid}_trustedform`)
    } else {
      this.props.onChange('trustedform', false)
      this.props.onChange('trustedform_cfid', '')
    }

  }

  render() {
    return (
      <div key={this.state.tcpaform.cfid || ''}>
        <Row className='mt-4'>
          {this.props.settings}
          <Col size='2'>
            <FormGroup>
              <Label>Trusted Form?</Label>
              <Switch
                onChange={(e) => this.handleEnableTrustedForm(e)}
                checked={this.state.tcpaform.trustedform || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>LeadId?</Label>
              <Switch
                onChange={(e) => this.handleEnableLeadId(e)}
                checked={this.state.tcpaform.leadid || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Always Visible?</Label>
              <Switch
                onChange={this.handleEnable('alwaysShow')}
                checked={this.state.tcpaform.alwaysShow || false}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Auto Scroll to Consent</Label>
              <Switch
                onChange={this.handleEnable('autoScrollToConsent')}
                checked={this.state.tcpaform.autoScrollToConsent || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Manual Submit</Label>
              <PureSwitch
                onChange={this.handleEnableManualSubmit}
                value={this.state.tcpaform.manualSubmit || false}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col size='2'>
            <FormGroup>
              <Label>Save Consent Text</Label>
              <Switch
                onChange={this.handleEnable('saveConsentText')}
                checked={this.state.tcpaform.saveConsentText || false}
                disabled={this.props.disabled}
              />
            </FormGroup>
          </Col>
          <Col size="12">
            <FormGroup>
              <Label>Title</Label>
              <CodeEditor
                name="question"
                value={this.state.tcpaform.question || ''}
                onChange={value => this.props.onChange('question', value)}
                disabled={this.props.disabled}
                resizable
                height="100px"
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}
TcpaFormForm.propTypes = {
  data: PropTypes.any,
  integrationData: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onCustomFieldClick: PropTypes.func
}

export default TcpaFormForm;
